import React, { useEffect, useState } from "react";
import api from "../api";

export default function EmployeeMaster() {

  const [employees, setEmployees] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    hourly_rate: ''
  });

  const load = async () => {
    try {
      const r = await api.get('/employees');
      setEmployees(r.data);
    } catch {
      alert('Failed to load employees');
    }
  };

  useEffect(() => { load(); }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
  await api.put(`/employees/${editingId}`, {
    name: form.name,
    email: form.email,
    phone: form.phone,
    hourly_rate: form.hourly_rate
  });

  alert('Updated');
}else {
        await api.post('/employees', form);
        alert('Created');
      }

      setForm({ name:'', email:'', phone:'', hourly_rate:'' });
      setEditingId(null);
      load();

    } catch (err) {
      alert('Error');
    }
  };

  const edit = (emp) => {
    setEditingId(emp.id);
    setForm({
      name: emp.user?.name || '',
      email: emp.user?.email || '',
      phone: emp.phone || '',
      hourly_rate: emp.hourly_rate || ''
    });
  };

  const remove = async (id) => {
    if (!window.confirm('Delete employee?')) return;

    await api.delete(`/employees/${id}`);
    load();
  };

  return (
    <div className="container mt-3">

      {/* 🔥 CENTER WRAPPER */}
      <div className="mx-auto" style={{ maxWidth: "900px" }}>

        <h4 className="mb-3">👷 Employee Master</h4>

        {/* FORM */}
        <form onSubmit={handleSubmit}>

          <div className="card p-3 mb-3 shadow-sm">

            <div className="row g-2">

              <div className="col-12 col-md-3">
                <input name="name" className="form-control"
                  placeholder="Name"
                  value={form.name}
                  onChange={handleChange}
                  required={!editingId}/>
              </div>

              <div className="col-12 col-md-3">
                <input name="email" type="email" className="form-control"
                  placeholder="Email"
                  value={form.email}
                  onChange={handleChange}
                  required={!editingId}/>
              </div>

              <div className="col-6 col-md-3">
                <input name="phone" className="form-control"
                  placeholder="Phone"
                  value={form.phone}
                  onChange={handleChange}/>
              </div>

              <div className="col-6 col-md-3">
                <input name="hourly_rate" type="number"
                  className="form-control"
                  placeholder="Hourly rate"
                  value={form.hourly_rate}
                  onChange={handleChange}/>
              </div>

            </div>

            {/* DESKTOP BUTTON */}
            <div className="d-none d-md-flex justify-content-center mt-3 gap-2">
              <button className="btn btn-primary px-4">
                {editingId ? 'Update' : 'Create'}
              </button>

              {editingId && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={()=>{
                    setEditingId(null);
                    setForm({ name:'', email:'', phone:'', hourly_rate:'' });
                  }}
                >
                  Cancel
                </button>
              )}
            </div>

          </div>

        </form>

        {/* MOBILE BUTTON */}
        <div className="d-md-none fixed-bottom bg-white p-2 border-top shadow">
          <button className="btn btn-primary w-100">
            {editingId ? 'Update' : 'Create'}
          </button>
        </div>

        <div className="d-md-none" style={{ height: "70px" }}></div>

        {/* ================= TABLE ================= */}

        <h5>Employees</h5>

        {/* DESKTOP TABLE */}
        <div className="d-none d-md-block">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Hourly</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {employees.map(emp => (
                <tr key={emp.id}>
                  <td>{emp.user?.name}</td>
                  <td>{emp.user?.email}</td>
                  <td>{emp.phone || '—'}</td>
                  <td>$ {emp.hourly_rate || '—'}</td>
                  <td>
                    <button className="btn btn-sm btn-warning me-2"
                      onClick={()=>edit(emp)}>Edit</button>

                    <button className="btn btn-sm btn-danger"
                      onClick={()=>remove(emp.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* MOBILE CARDS */}
        <div className="d-md-none">
          {employees.map(emp => (
            <div key={emp.id} className="card p-2 mb-2 shadow-sm">

              <div className="d-flex justify-content-between">
                <strong>{emp.user?.name}</strong>
                <span className="badge bg-success">
                  $ {emp.hourly_rate || '—'}
                </span>
              </div>

              <div className="small text-muted">
                {emp.user?.email}
              </div>

              <div className="small">
                📞 {emp.phone || '—'}
              </div>

              <div className="d-flex gap-2 mt-2">
                <button className="btn btn-sm btn-warning w-50"
                  onClick={()=>edit(emp)}>Edit</button>

                <button className="btn btn-sm btn-danger w-50"
                  onClick={()=>remove(emp.id)}>Delete</button>
              </div>

            </div>
          ))}
        </div>

      </div>
    </div>
  );
}